var _excluded = ["searchQuery", "map"],
  _excluded2 = ["searchQuery", "map"],
  _excluded3 = ["query", "localityMap"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _toArray(r) { return _arrayWithHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import upperFirst from 'lodash/upperFirst';
import toLower from 'lodash/toLower';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';
import isFunction from 'lodash/isFunction';
import cookie from 'react-cookie';
import querySearch from 'qs';
import { ListingType, LocalityType, ListingTypeName, ListingCategory, PropertyStatus, RentalType, getListingUseType, buildLocalityBreadcrumbs, buildSearchBreadcrumbs, ToggledFeatureKey, updateDigitalData } from '@domain-group/fe-allhomes-library';
import { SearchQuery, resolveLocalities, buildFilterSummary, Filters, searchApiFactory } from '@domain-group/fe-allhomes-search-api';
import { subjects } from '@domain-group/fe-co-allhomes-global-observer';
import queryPropType from '../proptypes/query';
import mapSearchPropType, { BOUNDS_PROPS } from '../proptypes/map-search';
import viewPropType, { VIEWS } from '../proptypes/view';
import locationMapPropType from '../proptypes/location-map';
import { regionGroupPropTypes } from '../proptypes/locality';
import { mapUtils, buildUrl, getValidSingleLocality } from '../utils';
import { jsx as ___EmotionJSX } from "@emotion/core";
var referrerCookieName = 'referrer';
var toSentenceCase = str => str && upperFirst(toLower(str));
var serialiseState = _ref => {
  var searchQuery = _ref.searchQuery,
    map = _ref.map,
    otherState = _objectWithoutProperties(_ref, _excluded);
  return _objectSpread(_objectSpread({}, otherState), {}, {
    searchQuery: searchQuery.getValues()
  });
};
var deserialiseState = (_ref2, _ref3) => {
  var listingType = _ref3.listingType;
  var searchQuery = _ref2.searchQuery,
    map = _ref2.map,
    otherState = _objectWithoutProperties(_ref2, _excluded2);
  return _objectSpread(_objectSpread({}, otherState), {}, {
    searchQuery: new SearchQuery(listingType, searchQuery),
    showSortDialogue: false,
    showFilterDialogue: false
  });
};
var getPageTitle = (listingType, division) => {
  if (division) {
    if (listingType.isCommercial) {
      var type = listingType === ListingType.SALES_BUSINESS ? 'Businesses' : 'Commercial real estate';
      var _prefix = toSentenceCase("".concat(type, " ").concat(listingType.titleFlavour, " in"));
      return "".concat(_prefix, " ").concat(division.name, ", ").concat(division.metaData.state, " ").concat(division.metaData.postcode).trim();
    }
    if (listingType.name === ListingType.DEVELOPMENTS_RESIDENTIAL.name) {
      var _prefix2 = toSentenceCase("New developments ".concat(listingType.titleFlavour, " in"));
      return "".concat(_prefix2, " ").concat(division.name, ", ").concat(division.metaData.state, " ").concat(division.metaData.postcode).trim();
    }
    var prefix = "Properties ".concat(listingType.titleFlavour.toLowerCase(), " in");
    return "".concat(prefix, " ").concat(division.name, ", ").concat(division.metaData.state, " ").concat(division.metaData.postcode).trim();
  }
  return toSentenceCase("".concat(listingType.name === ListingType.DEVELOPMENTS_RESIDENTIAL.name ? 'New developments' : "".concat(getListingUseType(listingType), " ").concat(listingType.shortLabel), " Search"));
};
var updateLocation = (state, _ref4, replaceState) => {
  var getAbsoluteUrl = _ref4.getAbsoluteUrl,
    listingType = _ref4.listingType,
    isNewSearchPage = _ref4.isNewSearchPage;
  var url;
  try {
    if (window) {
      // Don't do anything if we're on the server
      url = getAbsoluteUrl(buildUrl(state.searchQuery, {
        isNewSearchPage
      }));
      var topState = window.history.state;
      window.history[topState && (topState.showFilterDialogue || topState.showSortDialogue || replaceState) ? 'replaceState' : 'pushState'](serialiseState(state), '', url);

      // Update title
      var singleLocality = getValidSingleLocality(state.searchQuery, [LocalityType.DIVISION.type]);
      document.title = getPageTitle(ListingType[listingType], singleLocality);
    }
  } catch (error) {
    console.error("Failed to update URL to ".concat(url), error); // eslint-disable-line no-console
    // If updating fails, we don't want to hold up everything else.
  }
};
var getRedirectMessageState = props => {
  var redirectMessage = props.redirectMessage,
    propertyAlertName = props.propertyAlertName;
  if (!redirectMessage) {
    var referrer = cookie.load(referrerCookieName);
    if (referrer) {
      if (referrer.startsWith('MISSING_EA_LISTING:')) {
        // Split the cookie into two strings at the position of the first colon
        var colonPos = referrer.indexOf(':');
        redirectMessage = referrer.substr(0, colonPos);
        propertyAlertName = referrer.substr(colonPos + 1);
      } else {
        redirectMessage = 'LISTING_NOT_FOUND';
      }
      cookie.remove(referrerCookieName, {
        path: '/'
      });
    }
  }
  return {
    redirectMessage,
    propertyAlertName
  };
};
var searchApiWrapper = BaseComponent => {
  class SearchApiWrapper extends Component {
    constructor(props) {
      var _this;
      super(props);
      _this = this;
      _defineProperty(this, "getAbsoluteUrl", function () {
        return _this.props.getAbsoluteUrl(...arguments);
      });
      _defineProperty(this, "localityLookup", function () {
        return _this.props.localityLookup(...arguments);
      });
      _defineProperty(this, "buildSearchApi", () => searchApiFactory({
        backend: 'allhomes',
        isServerSide: true,
        endpoint: this.getAbsoluteUrl(this.props.endpoints.searchApiEndpoint)
      }));
      _defineProperty(this, "onPopState", event => {
        if (!event.state.searchQuery) {
          // Not our state - so we'll ignore it
          return;
        }
        if (this.state.showSortDialogue || this.state.showFilterDialogue) {
          this.setState({
            showFilterDialogue: false,
            showSortDialogue: false
          });
        } else {
          this.setState(deserialiseState(event.state, this.props));
        }
      });
      _defineProperty(this, "onSubmitFilter", newFilter => {
        var query = this.state.searchQuery.cloneWith({
          filters: Filters.valuesOf(newFilter),
          page: 1
        });
        this.performNewSearch(query);
      });
      _defineProperty(this, "onClearFilter", () => {
        var filters = this.state.searchQuery.filters;
        this.onSubmitFilter(new Filters(this.props.listingType, {
          localities: filters.localities
        }));
      });
      _defineProperty(this, "onToggleView", type => {
        var newOptions = null;
        if (type === VIEWS.MAP) {
          // When toggling the view we want to make set the bounds reset
          // state to true for map view. This is so we can adjust the bounds
          // after user is switiching from list view to map view.
          document.disableOnChange = true;
          this.setState({
            view: type
          }, () => {
            this.updateMap();
          });
          newOptions = {
            results: {
              type: 'MAP'
            }
          };
        } else {
          newOptions = {
            page: 1,
            results: {
              type: 'LIST'
            }
          };
        }
        var query = this.state.searchQuery.cloneWith(newOptions);
        this.performNewSearch(query);
        this.props.onToggleView(type);
      });
      _defineProperty(this, "onMapChange", event => {
        // We hold off the submission if the map boundaries
        // were updated changed. This happens when locality was added/removed
        // from the list.
        if (document.disableOnChange && !event.forceOnChange) {
          document.disableOnChange = false;
          return;
        }
        var filters = this.state.searchQuery.filters;
        this.onSubmitFilter(filters.cloneWith({
          bounds: event.bounds,
          localities: null
        }));
        document.disableOnChange = false;
      });
      _defineProperty(this, "onPageChange", (event, page) => {
        this.performNewSearch(this.state.searchQuery.cloneWith({
          page
        }));
        if (window) {
          window.scroll(0, 0);
        }
        event.preventDefault();
      });
      _defineProperty(this, "onSortChange", selection => {
        var sortQuery = SearchQuery.fromUrlParameters(this.props.listingType, {
          sort: selection
        });
        var filters = this.state.searchQuery.filters;
        this.performNewSearch(new SearchQuery(this.props.listingType, filters, {
          sort: sortQuery.sort.value,
          page: 1
        }));
      });
      _defineProperty(this, "onViewSold", () => {
        var filters = this.state.searchQuery.filters;
        var status = this.listingType.category === ListingCategory.RENT ? PropertyStatus.RENTED.name : PropertyStatus.SOLD.name;
        this.onSubmitFilter(filters.cloneWith({
          propertyStatus: this.state.isSoldPage ? undefined : [status]
        }));
        this.props.onViewSoldClick();
      });
      _defineProperty(this, "onExpandedBtrSearch", newLocalities => {
        var filters = this.state.searchQuery.filters;
        this.onSubmitFilter(filters.cloneWith({
          listedPropertyTypes: [RentalType.BUILD_TO_RENT.name],
          localities: newLocalities
        }));
      });
      _defineProperty(this, "onClearBtr", () => {
        var filters = this.state.searchQuery.filters;
        this.onSubmitFilter(filters.cloneWith({
          listedPropertyTypes: filters.listedPropertyTypes.default
        }));
      });
      _defineProperty(this, "onShowSortDialogue", showSortDialogue => {
        if (showSortDialogue) {
          this.setState({
            showSortDialogue
          }, () => {
            window.history.pushState(serialiseState(this.state), '');
          });
        } else {
          this.closeDialogues();
        }
      });
      _defineProperty(this, "onShowFilterDialogue", showFilterDialogue => {
        if (showFilterDialogue) {
          this.setState({
            showFilterDialogue
          }, () => {
            window.history.pushState(serialiseState(this.state), '');
          });
        } else {
          this.closeDialogues();
        }
      });
      _defineProperty(this, "getNthRightmostBreadcrumbLink", (breadcrumbs, indexFromRight) => breadcrumbs && breadcrumbs.length > indexFromRight ? breadcrumbs[breadcrumbs.length - indexFromRight].link : null);
      _defineProperty(this, "getStateFromQuery", searchQuery => {
        var _searchQuery$filters$;
        var localityList = searchQuery.getLocalities();
        var singleLocality = searchQuery.getSingleLocality();
        var ignoredParameters = ['sort', 'page', 'regions', 'divisions', 'streets', 'postcodes', 'districts'];
        var isDefaultSearch = isEmpty(searchQuery.toUrlParameters().filter(param => !ignoredParameters.includes(Object.keys(param)[0])));
        var isSoldPage = searchQuery.filters.propertyStatus && isEqual(searchQuery.filters.propertyStatus.selected, [PropertyStatus.SOLD.name]);
        var breadcrumbs = getValidSingleLocality(searchQuery, this.props.singleLocalityTypes) ? buildLocalityBreadcrumbs(this.getAbsoluteUrl, this.listingType, this.props.breadcrumbRules.bypassCanberra, singleLocality, isSoldPage, ...this.props.breadcrumbRules.additional) : buildSearchBreadcrumbs(this.getAbsoluteUrl, this.listingType, isSoldPage);
        return {
          searchQuery,
          isSoldPage: isSoldPage || isEqual((_searchQuery$filters$ = searchQuery.filters.propertyStatus) === null || _searchQuery$filters$ === void 0 ? void 0 : _searchQuery$filters$.selected, [PropertyStatus.RENTED.name]),
          isDefaultSearch,
          paginatorUrlTemplate: buildUrl(searchQuery, _objectSpread(_objectSpread({}, this.props), {}, {
            pageTemplate: true
          })),
          localityList,
          breadcrumbs,
          singleLocality,
          // Use the second-last breadcrumb for the "browse all suburbs" link
          allSuburbsLink: this.getNthRightmostBreadcrumbLink(breadcrumbs, 3)
        };
      });
      _defineProperty(this, "getClusteredListingCount", clusteredResults => clusteredResults.reduce((accum, item) => accum + item.count, 0));
      _defineProperty(this, "rebuildMap", _ref5 => {
        var _ref5$searchResults = _ref5.searchResults,
          searchResults = _ref5$searchResults === void 0 ? [] : _ref5$searchResults,
          _ref5$clusteredResult = _ref5.clusteredResults,
          clusteredResults = _ref5$clusteredResult === void 0 ? [] : _ref5$clusteredResult,
          _ref5$hiddenPropertie = _ref5.hiddenProperties,
          hiddenProperties = _ref5$hiddenPropertie === void 0 ? 0 : _ref5$hiddenPropertie,
          _ref5$totalHits = _ref5.totalHits,
          totalHits = _ref5$totalHits === void 0 ? 0 : _ref5$totalHits,
          _ref5$bounds = _ref5.bounds,
          bounds = _ref5$bounds === void 0 ? null : _ref5$bounds;
        var totalPinsDisplayed = this.getClusteredListingCount(clusteredResults) + searchResults.length + hiddenProperties;
        var newMapProps = _objectSpread(_objectSpread({}, this.state.map), {}, {
          markers: mapUtils.listingToMarkers(searchResults, clusteredResults),
          onChange: this.onMapChange,
          hiddenProperties,
          isTruncatedResult: totalHits > totalPinsDisplayed
        });
        if (bounds) {
          newMapProps.defaultCenter = mapUtils.boundsToCenter(bounds);
        }
        return newMapProps;
      });
      _defineProperty(this, "updateMap", () => {
        var totalPinsDisplayed = this.getClusteredListingCount(this.state.clusteredResults) + this.state.searchResults.length + this.state.suppressedResults;
        this.setState(prevState => ({
          map: this.rebuildMap({
            searchResults: prevState.searchResults,
            clusteredResults: prevState.clusteredResults,
            bounds: prevState.bounds,
            hiddenProperties: prevState.suppressedResults,
            isTruncatedResult: prevState.totalHits > totalPinsDisplayed
          })
        }));
      });
      _defineProperty(this, "isMapView", () => isEqual(this.state.view, VIEWS.MAP));
      _defineProperty(this, "closeDialogues", () => {
        if (this.state.showFilterDialogue || this.state.showSortDialogue) {
          window.history.go(-1);
        }
      });
      _defineProperty(this, "updateDigitalData", function (query) {
        var searchResults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        var totalPages = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
        try {
          var newDigitalData = updateDigitalData(window.digitalData, query, _this.listingType, searchResults, totalPages);
          var titanChanged = !isEqual(window.digitalData.titan, newDigitalData.titan);
          window.digitalData = newDigitalData;
          if (titanChanged && get(window, 'titan.refreshAds')) {
            window.titan.refreshAds();
          }
        } catch (error) {
          // Don't stall reload on error
          console.error('Error updating digitalData', error); // eslint-disable-line no-console
        }
      });
      /**
       * Extra tasks are functions that accept the search query object as an argument and return
       * a promise that eventually resolves an object that can be added to the internal state.
       * These tasks are executed whenever `this.performNewSearch()` is called.
       */
      _defineProperty(this, "runExtraTasks", query => this.props.extraTasks.map(task => {
        if (isFunction(task)) {
          return Promise.resolve(task(query, this.props, this.state));
        }
        return Promise.resolve({});
      }));
      _defineProperty(this, "flattenExtraTaskResults", function () {
        var taskResults = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        return taskResults.reduce((state, taskResult) => _objectSpread(_objectSpread({}, state), taskResult), {});
      });
      _defineProperty(this, "performNewSearch", query => {
        this.closeMessage();
        this.setState({
          searchPending: true,
          showSortDialogue: false,
          showFilterDialogue: false,
          redirectMessage: undefined,
          propertyAlertName: undefined
        });
        try {
          var _this$props$toggledFe, _this$props$toggledFe2;
          var requiresParents = [LocalityType.STREET.type, LocalityType.DIVISION.type, LocalityType.DISTRICT.type];
          var localityMapPromise = resolveLocalities(query, this.localityLookup, this.localityMap, requiresParents).then(localityMap => {
            this.localityMap = localityMap;
            query.resolveLocalities(localityMap, true);
            return this.getStateFromQuery(query);
          });
          if (this.isMapView() && !query.filters.bounds) {
            // Locality was added or removed from the search
            // while we are on map view - non MAP AREA search
            document.disableOnChange = true;
          }
          var btrEnabled = (_this$props$toggledFe = this.props.toggledFeatures) === null || _this$props$toggledFe === void 0 ? void 0 : _this$props$toggledFe[ToggledFeatureKey.BUILD_TO_RENT];
          if (!btrEnabled && this.listingType.name === ListingTypeName.RENTAL_RESIDENTIAL) {
            // Patch BTR out of existence if it's not enabled
            var listedPropertyTypes = query.filters.listedPropertyTypes;
            var defaults = listedPropertyTypes.default.filter(type => type !== RentalType.BUILD_TO_RENT.name);
            listedPropertyTypes.selected = listedPropertyTypes.selected ? listedPropertyTypes.selected.filter(type => type !== RentalType.BUILD_TO_RENT.name) : defaults;
          }
          var searchApi = this.buildSearchApi();
          var strictNewListings = (_this$props$toggledFe2 = this.props.toggledFeatures) === null || _this$props$toggledFe2 === void 0 ? void 0 : _this$props$toggledFe2[ToggledFeatureKey.STRICT_NEW_LISTINGS];
          var searchPromise = searchApi.fetchListings(this.listingType, query);
          var countPromise = query.searchType === 'new-listings' && strictNewListings ? searchApi.fetchListings(this.listingType, query.cloneWith({
            searchType: 'strict-new-listings',
            pageSize: 0
          })) : searchPromise;
          var extraTaskPromises = this.runExtraTasks(query);
          var isLocalitiesChanged = !isEqual(this.state.searchQuery.filters.getValues().localities, query.filters.getValues().localities) && !isEmpty(query.filters.getValues().localities);
          if (typeof document !== 'undefined') {
            // state is asyncronous, we will need this flag as soon as it is set
            // as we do not want extra calculations done on the map because we'd
            // be waiting for async call (of setState) to finish
            // so we use document object
            document.recalculateBounds = isLocalitiesChanged || !isEqual(get(this.state.searchQuery, 'results.type'), get(query, 'results.type'));
          }
          Promise.all([localityMapPromise, searchPromise, countPromise, ...extraTaskPromises]).then(_ref6 => {
            var _ref7 = _toArray(_ref6),
              getStateFromQuery = _ref7[0],
              _ref7$ = _ref7[1],
              _ref7$$searchResults = _ref7$.searchResults,
              searchResults = _ref7$$searchResults === void 0 ? [] : _ref7$$searchResults,
              _ref7$$clusteredResul = _ref7$.clusteredResults,
              clusteredResults = _ref7$$clusteredResul === void 0 ? [] : _ref7$$clusteredResul,
              numPages = _ref7$.numPages,
              bounds = _ref7$.bounds,
              _ref7$$suppressedResu = _ref7$.suppressedResults,
              suppressedResults = _ref7$$suppressedResu === void 0 ? 0 : _ref7$$suppressedResu,
              totalHits = _ref7[2].totalHits,
              extraTaskResults = _ref7.slice(3);
            var map = this.state.map;
            var newBounds = bounds || query.filters.bounds;
            if (this.isMapView()) {
              // if bounds were reset (locality was added / removed from the search)
              // we use the new bounds from the response. This is because elastic search
              // gave us new bounds that fit all the pins in the map.
              var updatedBounds = query.filters.bounds ? {} : {
                bounds: newBounds
              };
              map = this.rebuildMap(_objectSpread({
                searchResults,
                clusteredResults,
                hiddenProperties: suppressedResults,
                totalHits
              }, updatedBounds));
              map.bounds = bounds;
            }
            this.updateDigitalData(query, searchResults, numPages);
            try {
              this.props.onPerformSearch(query);
            } catch (error) {
              console.error('Error when firing onPerformSearch', error); // eslint-disable-line no-console
            }
            this.setState(_objectSpread(_objectSpread(_objectSpread({
              searchPending: false,
              searchResults,
              clusteredResults,
              totalHits,
              totalPages: numPages,
              suppressedResults,
              bounds: newBounds
            }, this.flattenExtraTaskResults(extraTaskResults)), getStateFromQuery), {}, {
              map
            }), () => {
              updateLocation(this.state, this.props);
              this.updateDynamicFooter();
              this.props.onSearchQueryChange(this.state.searchQuery);
            });
          });
        } catch (error) {
          console.error(error); // eslint-disable-line no-console
          this.setState({
            searchPending: false
          });
        }
      });
      _defineProperty(this, "updateDynamicFooter", () => {
        var options = {};
        if (this.state.singleLocality && LocalityType.DIVISION.type === this.state.singleLocality.type) {
          options.divisionId = this.state.singleLocality.id;
        }
        this.props.notifyObservers(subjects.dynamicFooterUpdate, options);
      });
      _defineProperty(this, "closeMessage", () => {
        this.setState({
          displayMessage: false,
          messageType: ''
        });
      });
      _defineProperty(this, "undoDelete", () => {
        if (this.alert) {
          this.props.createPropertyAlert(this.alert).then(result => {
            if (result && result.id) {
              this.setState({
                displayMessage: false
              });
              this.alert = null;
              this.checkPropertyAlert();
            }
          });
        }
      });
      _defineProperty(this, "onCreateAlert", alert => {
        this.updateAlertState({
          alert
        });
        return this.props.onCreateAlert(alert);
      });
      _defineProperty(this, "deleteConfirmation", () => {
        this.setState({
          displayMessage: true,
          messageType: 'error'
        });
      });
      _defineProperty(this, "updateAlertState", function () {
        var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          alert = _ref8.alert,
          earlyAccessEnabled = _ref8.earlyAccessEnabled;
        var hasAlert = alert && alert.id;
        _this.setState(_objectSpread(_objectSpread({}, earlyAccessEnabled != null && {
          earlyAccessEnabled
        }), {}, {
          alertId: hasAlert ? alert.id : null,
          alertName: hasAlert ? alert.name : null,
          filterSummary: hasAlert ? buildFilterSummary(new SearchQuery(_this.props.listingType, alert.query)) : ''
        }));
        _this.alert = hasAlert ? {
          id: alert.id,
          listingType: alert.listingType,
          query: alert.query,
          name: alert.name,
          frequency: alert.frequency
        } : null;
      });
      _defineProperty(this, "checkPropertyAlert", () => {
        this.props.checkPropertyAlert(this.state.searchQuery.getValues(), this.listingType.name).then(result => this.updateAlertState(result));
      });
      var _searchQuery = SearchQuery.fromQueryObject(this.props.listingType, this.props.query);
      this.localityMap = this.props.localityMap;
      _searchQuery.resolveLocalities(this.localityMap, true);
      this.listingType = ListingType[this.props.listingType];
      var _map = this.props.bounds ? _objectSpread(_objectSpread({}, this.props.map), {}, {
        defaultCenter: mapUtils.boundsToCenter(this.props.bounds),
        bounds: this.props.bounds
      }) : _objectSpread(_objectSpread({}, this.props.map), {}, {
        defaultCenter: mapUtils.centroidToCenter(_searchQuery.getLocalities())
      });
      this.state = _objectSpread(_objectSpread({
        searchPending: false,
        searchResults: this.props.initialSearchResults,
        btrMoreResults: this.props.initialBTRMoreResults,
        clusteredResults: this.props.initialClusteredResults,
        totalHits: this.props.totalHits,
        totalPages: this.props.totalPages,
        suppressedResults: this.props.suppressedResults,
        bounds: this.props.bounds
      }, this.getStateFromQuery(_searchQuery)), {}, {
        showSortDialogue: false,
        showFilterDialogue: false,
        regionGroup: this.props.regionGroup,
        featuredProperties: this.props.featuredProperties,
        inlineAds: this.props.inlineAds,
        view: this.props.view,
        map: _map,
        redirectMessage: undefined,
        propertyAlertName: undefined,
        displayMessage: false,
        messageType: '',
        alertId: null,
        alertName: null,
        filterSummary: ''
      });
      this.alert = null;
    }
    componentDidMount() {
      if (typeof window !== 'undefined') {
        this.setState(getRedirectMessageState(this.props));

        // Ensure there's some state saved from the first load.
        window.history.replaceState(serialiseState(this.state), '');
        window.addEventListener('popstate', this.onPopState);
        if (this.isMapView()) {
          // Triggle toggle view when HOC is mounted
          // so we populate correct map props based on
          // current state
          this.updateMap();
        }
        var _querySearch$parse = querySearch.parse(window.location.search, {
            ignoreQueryPrefix: true
          }),
          from = _querySearch$parse.from;
        if (from === 'edit-pa') {
          this.setState({
            displayMessage: true,
            messageType: 'info'
          });
          updateLocation(this.state, this.props, true);
        }
      }
    }
    componentDidUpdate(prevProps, prevState) {
      var isSignedIn = this.props.isSignedIn;
      var wasLoggedOut = !prevProps.isSignedIn;
      var searchIsDifferent = !isEqual(this.state.searchQuery && this.state.searchQuery.toQueryObject(), prevState.searchQuery && prevState.searchQuery.toQueryObject());
      if (isSignedIn && (wasLoggedOut || searchIsDifferent)) {
        this.checkPropertyAlert();
      } else if (!isSignedIn && !wasLoggedOut) {
        this.updateAlertState();
      }
    }
    componentWillUnmount() {
      if (typeof window !== 'undefined') {
        window.removeEventListener('popstate', this.onPopState);
      }
    }
    render() {
      var _this$props = this.props,
        query = _this$props.query,
        localityMap = _this$props.localityMap,
        otherProps = _objectWithoutProperties(_this$props, _excluded3);
      var searchQuery = this.state.searchQuery;
      return ___EmotionJSX(BaseComponent, _extends({}, otherProps, {
        searchResults: this.state.searchResults,
        btrMoreResults: this.state.btrMoreResults,
        clusteredResults: this.state.clusteredResults,
        suppressedResults: this.state.suppressedResults,
        inlineAds: this.state.inlineAds,
        searchQuery: searchQuery,
        isDefaultSearch: this.state.isDefaultSearch,
        isSoldPage: this.state.isSoldPage,
        singleLocality: this.state.singleLocality,
        localityLength: this.state.localityList.length,
        totalHits: this.state.totalHits,
        totalPages: this.state.totalPages,
        showFilterDialogue: this.state.showFilterDialogue,
        showSortDialogue: this.state.showSortDialogue,
        searchPending: this.state.searchPending,
        breadcrumbs: this.state.breadcrumbs,
        paginatorUrlTemplate: this.state.paginatorUrlTemplate,
        onSubmitFilter: this.onSubmitFilter,
        onClearFilter: this.onClearFilter,
        onClearBtr: this.onClearBtr,
        onExpandedBtrSearch: this.onExpandedBtrSearch,
        onPageChange: this.onPageChange,
        onSortChange: this.onSortChange,
        onViewSoldClick: this.onViewSold,
        onShowSortDialogue: this.onShowSortDialogue,
        onShowFilterDialogue: this.onShowFilterDialogue,
        regionGroup: this.state.regionGroup,
        featuredProperties: this.state.featuredProperties,
        allSuburbsLink: this.state.allSuburbsLink,
        onToggleView: this.onToggleView,
        map: this.state.map,
        redirectMessage: this.state.redirectMessage,
        propertyAlertName: this.state.propertyAlertName,
        displayMessage: this.state.displayMessage,
        messageType: this.state.messageType,
        alertId: this.state.alertId,
        alertName: this.state.alertName,
        earlyAccessEnabled: this.state.earlyAccessEnabled,
        filterSummary: this.state.filterSummary,
        closeMessage: this.closeMessage,
        undoDelete: this.undoDelete,
        deleteConfirmation: this.deleteConfirmation,
        onCreateAlert: this.onCreateAlert,
        buildSearchApi: this.buildSearchApi
      }));
    }
  }

  /* eslint-disable react/forbid-prop-types */
  SearchApiWrapper.propTypes = {
    listingType: PropTypes.string.isRequired,
    query: queryPropType.isRequired,
    localityMap: locationMapPropType,
    initialSearchResults: PropTypes.array,
    // eslint-disable-line react/forbid-prop-types
    initialBTRMoreResults: PropTypes.shape({
      newsArticles: PropTypes.array.isRequired,
      // eslint-disable-line react/forbid-prop-types
      searchResults: PropTypes.array.isRequired,
      // eslint-disable-line react/forbid-prop-types
      totalHits: PropTypes.number.isRequired
    }),
    initialClusteredResults: PropTypes.array,
    // eslint-disable-line react/forbid-prop-types
    inlineAds: PropTypes.shape({
      urls: PropTypes.arrayOf(PropTypes.string).isRequired,
      numberOfListingsPerAd: PropTypes.number.isRequired
    }),
    getAbsoluteUrl: PropTypes.func,
    totalHits: PropTypes.number.isRequired,
    totalPages: PropTypes.number.isRequired,
    suppressedResults: PropTypes.number,
    breadcrumbRules: PropTypes.shape({
      additional: PropTypes.array,
      // eslint-disable-line react/forbid-prop-types
      bypassCanberra: PropTypes.bool
    }),
    extraTasks: PropTypes.arrayOf(PropTypes.func),
    regionGroup: regionGroupPropTypes,
    endpoints: PropTypes.objectOf(PropTypes.string),
    featuredProperties: PropTypes.array,
    // eslint-disable-line react/forbid-prop-types
    onViewSoldClick: PropTypes.func,
    onPerformSearch: PropTypes.func,
    isNewSearchPage: PropTypes.bool,
    singleLocalityTypes: PropTypes.arrayOf(PropTypes.string),
    notifyObservers: PropTypes.func,
    view: viewPropType,
    bounds: PropTypes.shape(BOUNDS_PROPS),
    map: mapSearchPropType,
    onToggleView: PropTypes.func,
    redirectMessage: PropTypes.string,
    propertyAlertName: PropTypes.string,
    searchQuery: PropTypes.string,
    displayMessage: PropTypes.bool,
    messageType: PropTypes.string,
    closeMessage: PropTypes.func,
    undoDelete: PropTypes.func,
    deleteConfirmation: PropTypes.func,
    createPropertyAlert: PropTypes.func,
    checkPropertyAlert: PropTypes.func,
    onCreateAlert: PropTypes.func,
    onSearchQueryChange: PropTypes.func,
    isSignedIn: PropTypes.bool,
    toggledFeatures: PropTypes.object,
    localityLookup: PropTypes.func
  };
  SearchApiWrapper.defaultProps = {
    localityMap: {},
    initialSearchResults: [],
    initialBTRMoreResults: null,
    initialClusteredResults: [],
    inlineAds: {
      numberOfListingsPerAd: 6,
      urls: []
    },
    getAbsoluteUrl: url => url,
    breadcrumbRules: {
      additional: [],
      bypassCanberra: true
    },
    extraTasks: [],
    regionGroup: {},
    endpoints: {},
    featuredProperties: [],
    suppressedResults: 0,
    onToggleView: () => {},
    onViewSoldClick: () => {},
    onPerformSearch: () => {},
    isNewSearchPage: false,
    singleLocalityTypes: [LocalityType.DIVISION.type],
    notifyObservers: () => {},
    view: VIEWS.LIST,
    map: null,
    bounds: null,
    redirectMessage: undefined,
    propertyAlertName: undefined,
    searchQuery: '',
    closeMessage: () => {},
    undoDelete: () => {},
    deleteConfirmation: () => {},
    displayMessage: false,
    messageType: '',
    createPropertyAlert: undefined,
    checkPropertyAlert: undefined,
    onCreateAlert: () => {},
    onSearchQueryChange: () => {},
    isSignedIn: false,
    toggledFeatures: {},
    localityLookup: () => []
  };
  return SearchApiWrapper;
};
export default searchApiWrapper;